import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function ChevronRightIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox={'0 0 18 32'} fontSize={'inherit'} {...props}>
      <path d="M3.387 32l14.675-16-14.675-16-3.45 3.76 11.2 12.24-11.2 12.24z"></path>
    </SvgIcon>
  );
}
